














import { GeekItem } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'GeekFullName',
  props: {
    geek: Object as () => GeekItem,
    asLink: Boolean,
  },
  methods: {
    showProfile() {
      this.$router.push({
          name: 'geek-profile',
          params: {
            geekId: this.geek.id,
          },
      });
    },
  },
});
